import api from '@service/DataService';

export async function createBlog(blog) {
  try {
    const req = await api.post('/blogs', blog);
    return req.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
}

export async function getBlogService(payload) {
  try {
    const params = new URLSearchParams({
      page: payload.page,
      limit: payload.limit,
      ...(payload.search && { search: payload.search }),
      ...(payload.status && { status: payload.status })
    });
    const req = await api.get(`/blogs?${params.toString()}`);
    const res = req.data;

    return res?.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
}

export const getSingleBlogService = async (id) => {
  try {
    const req = await api.get(`/blogs/${id}`);
    const res = req.data;
    return res?.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
};

export const updateBlogService = async (id, blog) => {
  try {
    const req = await api.patch(`/blogs/${id}`, blog);
    return req.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
};

export const deleteBlogService = async (id) => {
  try {
    const req = await api.delete(`/blogs/${id}`);
    return req.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
};

export const generateBlog = async (payload) => {
  try {
    const req = await api.post(`/blogs/generate-draft`, payload);
    return req.data;
  } catch (error) {
    const apiError = error.response?.data; // ← the actual response body
    throw new Error(apiError?.message ?? error.message);
  }
};
